<template>
  <a
    class="rs-listing__card rs-book-listing__card"
    :href="post.permalink"
    :lang="post.lang"
    :hreflang="post.lang"
    :dir="post.lang_dir"
  >
    <div
      class="rs-listing__card__image rs-book-listing__card__image"
      v-html="post.featured_image"
    ></div>

    <!-- <div v-if="(post.rs_book_format && post.rs_book_format.length) || (post.rs_book_language && post.rs_book_language.length)" class="rs-listing__card__categories">
      <span v-for="(bookFormat, i) in post.rs_book_format" :key="bookFormat.slug">
        <span v-if="i > 0">, </span>
        <a :href="bookFormat.permalink" v-html="bookFormat.name"></a>
      </span>
      <span v-if="post.rs_book_format.length && post.rs_book_language.length"> • </span>
      <span v-for="(bookLanguage, i) in post.rs_book_language" :key="bookLanguage.slug">
        <span v-if="i > 0">, </span>
        <a :href="bookLanguage.permalink" v-html="bookLanguage.name"></a>
      </span>
    </div> -->

    <div
      class="rs-listing__card__title rs-book-listing__card__title"
      v-html="post.post_title"
    ></div>

    <div
      class="rs-listing__card__description"
      v-html="post.page_subtitle"
    ></div>
    
    <div class="rs-listing__card__footer">
      <div class="rs-listing__card__footer__cta">
        <span v-html="fetchedStrings['Read More'] + ' &gt;'" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    baseURL: String,
    post: Object,
    fetchedStrings: Object,
  },
};
</script>
